<template>
	<div class="create-strategy">
		<div class="transaction form-box">
			<div class="title">策略</div>
			<custom-select v-model="form.strategy_name" label="策略名称" :required="true" clearable input-align="left"
				placeholder="请选择策略名称" :columns="strategyNamelistData" readonly @change="changeStrategyName">
			</custom-select>
			<div  :class="{nobor: !wordKey}">
				<div class="van-hairline--bottom codeBox">
					<van-field :required="true" v-model="wordKey" @input="getQuoteSymbolApi" label="合约代码"
						placeholder="请输入名称代码" right-icon="search" />
					<van-overlay :show="symbolListShow" class="overlay-top" :lock-scroll="false"
						style="max-width: 1000px;transform: translateX(-50%);left:50%">
						<div class="symbolList-box" v-if="symbolListData && symbolListData.length > 0">
							<van-cell-group>
								<van-cell :title="item.origin_symbol" :value="item.contract_name" v-for="item in symbolListData" :key="item.symbol"
								@click="checkStockName(item)">
									<template #extra>
										<span class="is_main" v-if="item.is_main == 1">主力</span>
									</template>
								</van-cell>
							</van-cell-group>
						</div>
						<!-- 无搜索结果 -->
						<div class="noData" v-else>
						<img class="icon" src="@/assets/images/h5Page/prompt.png"/>
						<span class="text">暂无搜索结果</span>
						</div>
					</van-overlay>
				</div>
				<div class="sock-msg" v-if="wordKey">
					<div class="cont" :class="{up: currentSymbolTickData && currentSymbolTickData.change_value > 0, down: currentSymbolTickData && currentSymbolTickData.change_value < 0}">
						<span>{{currentSymbolTickData ? parseFloatNumber(currentSymbolTickData.last_price) : '--'}}</span>
						<span>{{currentSymbolTickData ? parseFloatNumber(currentSymbolTickData.change_value) : '--'}}</span>
						<span>
							{{currentSymbolTickData ? parseFloatNumber(currentSymbolTickData.change_rate, 2) : '--'}}{{currentSymbolTickData && currentSymbolTickData.change_rate !== undefined ? '%' : ''}}
						</span>
					</div>
				</div>
			</div>
			<!-- 网格策略条件 -->
			<div class="last" v-if="form.strategy_type == 1">
				<van-field :required="true" label="价格区间" placeholder="请输入内容">
					<template #input>
						<div class="ipt-box">
							<van-field v-model="strategy_param.min" type="number" class="van-hairline--surround" @input="checkMaxMin" placeholder="请输入最低价" />
							<span class="t">～</span>
							<van-field v-model="strategy_param.max" type="number" class="van-hairline--surround" @input="checkMaxMin" placeholder="请输入最高价" />
						</div>
					</template>
				</van-field>
				<div class="tips van-hairline--bottom" v-if="false">
					警告：{{strategy_param.max > currentSymbolTickData.pre_closing_price * 1.1 ? '最高价' : '最低价'}}已超过上个交易日收盘价的10%
				</div>
				<div class="van-hairline--bottom">
					<van-field :required="true" v-model="strategy_param.grid_size" type="number" label="格子大小" @input="checkMaxMin"  placeholder="请输入格子大小" />
				</div>
			</div>
			<!-- 开盘动量条件 -->
			<div  v-else-if="form.strategy_type == 2">
				<div class="van-hairline--bottom">
					<custom-select class="nobor" v-model="strategy_param.order_side" :columns="directionOptions" label="方向" :required="true" clearable
						input-align="left" placeholder="请选择方向" readonly @change="onDirectionChange">
					</custom-select>
				</div>
			</div>

			<!-- 日内断线-->
			<template v-if="form.strategy_type == 3">
				<div class="item van-hairline--bottom">
				<van-cell center title="是否隔夜">
					<template #right-icon>
					<van-switch v-model="strategy_param.isOverNight" :active-value="1" :inactive-value="0" size="18" inactive-color="#dcdee0" active-color="#1C0955" />
					</template>
				</van-cell>
				</div>
			</template>
		</div>

		<!-- 交易模块 -->
		<div class="transaction form-box">
			<div class="title">交易</div>
			<div class="box">
				<div class="van-hairline--bottom">
					<custom-select class="nobor " v-model="trade_param.order_type" :columns="wayCurrencyColumns" label="下单方式" :required="true" clearable
						input-align="left" placeholder="请选择下单方式" readonly  @change="handWayChange">
					</custom-select>
				</div>
				<div class="van-hairline--bottom">
					<custom-select class="nobor "  v-model="form.account_no" :columns="trade_param.order_type == 1 ? groupColumns : accountColumns" label="交易账号" :required="true" clearable
						input-align="left" placeholder="请选择交易账号" readonly  @change="changeAccountName">
					</custom-select>
				</div>
				<!-- 手数 -->
				<div class="item van-hairline--bottom">
					<custom-select class="nobor" v-model="trade_param.modeType" :columns="typeData" label="参考手数" :required="true" clearable
						input-align="left" placeholder="请选择类型" readonly  @change="changeCount">
					</custom-select>
					<van-field class="count" v-model="strategy_param.count"  placeholder="请输入手数" />
					<div class="btn-box">
						<div class="btn del" @click="countAddDel('del', 1)"></div>
						<div class="btn add" @click="countAddDel('add', 1)"></div>
					</div>
				</div>
				<!-- 账户列表 -->
				<div v-if="form.account_no && loadingAccount">
					<accountList :type="trade_param.modeType" :accounts="trade_param.order_type == 1 ? accountColumns : accountActiveData" :count="strategy_param.count" @markMultiple="markMultiple" />
				</div>
			</div>
		</div>

		<div class="btn-submit" @click="submitCheck">提交</div>

		<!-- 二次确认弹窗 -->
		<van-dialog v-model="confirmDialogShow"
			class="confirm-dialog"
			title="操作确认"
			width="90vw"
			:show-confirm-button="false"
			style="max-width: 900px;">
			<div class="main">
				<template v-for="(item, index) in confirmErrorList">
					<div class="text">
						<span>{{index + 1}}、</span>
						<p v-html="item"></p>
					</div>
				</template>
				<p class="tip">注意：该配置，策略执行存在风险，请谨慎提交。</p>
			</div>
			<div class="btn-box">
				<div class="btn-item" @click="submit">继续提交</div>
				<div class="btn-item" @click="toChange">去修改</div>
			</div>
		</van-dialog>
	</div>
</template>

<script>
	import CustomSelect from "@/views/create-account/components/CustomSelect.vue";
	import accountList from "./components/accountList.vue";
	import 'vant/lib/divider/style';
	import {
		Field,
		CellGroup,
		Overlay,
		Cell,
		Button,
		Toast,
		Dialog,
    Switch
	} from 'vant';
  import bus from "@/utils/bus";
	export default {
		components: {
			CustomSelect,
			[Button.name]: Button,
			[Field.name]: Field,
			[CellGroup.name]: CellGroup,
			[Overlay.name]: Overlay,
			[Cell.name]: Cell,
			[Dialog.Component.name]: Dialog.Component,
			accountList,
      		[Switch.name]: Switch
		},
		computed: {
			parseFloatNumber(){
				return (val, len) => {
					return val === undefined ? '--' : parseFloat(val).toFixed(len || this.currentSymbolData.digits);
				}
			},
			// 是否提示最大值警告
			isShowMaxTips(){
				let { max, min } = this.strategy_param;
				let { currentSymbolTickData } = this;
				if((max || min) && currentSymbolTickData){
					let { pre_closing_price } = currentSymbolTickData;
					return ((max || min) && pre_closing_price  ) && (max > pre_closing_price * 1.1 || min > pre_closing_price * 1.1);
				}else{
					return false;
				}

			}
		},
		data() {
			this.directionOptions = [
				{ value: '66', text: '买入' },
				{ value: '83', text: '卖出' }
			];
			this.typeData = [
				{ text: '按固定', type: 1, value: 1 },
				{ text: '按倍数', type: 2, value: 2 },
			]
			this.wayCurrencyColumns = [
				{ text: "按组", value: 1 },
        		{ text: "按账户", value: 2 }
      		];
			this.account_no = null;		// 存储选中的交易账号
			return {
				strategyNamelistData: [], // 策略名称列表
				accountColumns: [], // 交易账号列表
				accountActiveData: [],  // 单个交易账号列表
				groupColumns: [],  // 组列表
				symbolListShow: false, // 是否显示名称搜索下拉
				symbolListData: [], // 名称代码搜索结果
				wordKey: '', // 搜索字段
				loadingAccount: false,  // 账户列表是否显示
				trade_param: {
					order_type: 2,		// 下单方式
					modeType: 1			// 参考手数
				},
				form: {
					account_no: '', // 账号
					strategy_id: '',// 策略id
					strategy_name: '', // 策略名称
					strategy_type: '', // 策略类型 0-网格
					symbol: '', // Symbol(HKEX_HSI2310)
					exchange_code: '', // 交易所
					account_type: '', // 账户类型 1-期货，2-证券
					commodity_type: '', // 品种类型
					commodity_no:'', //品种编码
					contract_no: '', //合约
					strategy_param: '', // 策略参数
				},
				strategy_param: {
					min: '',
					max: '',
					grid_size:'',
					count: 5,
					order_side: '',
          			isOverNight: 0
				}, // 参数不定，策略类型不一 参数不一
				currentSymbolData: '', // 当前名称代码信息
				currentSymbolTickData: '', // 当前名称代码 tick 信息
				confirmDialogShow: false, // 二次确认
				confirmErrorList: []
      }
		},
		created() {
			let { auto_id, strategyId } = this.$route.query;
			this.auto_id = auto_id;
			this.setStrategyId(strategyId)
			// 根据auto_id是否存在判断 编辑/新增
			let title = auto_id ? '编辑计划' : '添加计划';
			this.$route.meta.title = title;
			document.title = title;
			// openWebSocket();
			this.init();
			bus.$on("onmessage", res => {
				this.getSockMsg(res);
			})
		},
		methods: {
			async init() {
				await this.getStrategyNameList();
				// 调取详情接口 如果是从修改倍数页返回则不拉取详情接口
				if ( this.auto_id && !localStorage.getItem('markMultiple') ){
					this.getStrategyInfoApi();
				} else {
					this.loadCachedData();
				}
				// 及时删除倍数标记
				localStorage.removeItem('markMultiple');
			},
			async fetchDataSequence() {
				await this.getListOfAccounts();
				await this.getGroupTradeList();
				this.chooseAccount();
			},
			// 获取账户列表
			getListOfAccounts() {
				return this.$apis.getGroupList({
					show_account: 2,
					is_empty_hide: 1
				}).then(res => {
					this.accountColumns = [];
					this.groupColumns = [];
					if (res && res.length > 0) {
						res.map(item => {
							if(item.type == 1){
								// 按账号数据处理
								item.account_list.map(cItem => {
									let obj = {
										text: `${cItem.futures_login_id}(${cItem.futures_name})`,
										value: cItem.futures_login_id,
										...item
									}
									this.accountColumns.push(obj)
								})
								// 按组数据处理
								let obj = {
									text: item.group_name,
									value: item.id,
									...item
								}
								this.groupColumns.push(obj);
							}
						})
					}
				}).catch(error => {
					// 处理 Promise 被 reject 的情况
					
				});
			},
			getGroupTradeList() {
				return this.$apis.groupTradeList({ group_id: 1 }).then(res => {
					if (!res) {
						
						return false;
					}
					if (Array.isArray(res) && res.length > 0) {
						// 为每个账户添加对应的倍数
						this.accountColumns.forEach( item => {
							const index = res.findIndex( cItem => item.value == cItem.account_no);
							if (index != -1) {
								this.$set(item, 'multiple', res[index].multiple);
							} else {
								this.$set(item, 'multiple', 1);
							}
						})
					}
					this.loadingAccount = true;
				}).catch(error => {
					// 处理 Promise 被 reject 的情况
					
					this.loadingAccount = true;
				});
			},
			chooseAccount() {
				// 如果 order_type 为 1，从 组列表 数组的第一个元素中获取 value 属性 否则从账户列表中取
				if (this.trade_param.order_type == 1) {
					this.$set(this.form, 'account_no', this.account_no || (this.groupColumns[0]?.value || ''));
					this.$set(this.form, 'account_type', this.form.account_type || (this.groupColumns[0]?.type || ''));
				} else {
					this.$set(this.form, 'account_no', this.account_no || (this.accountColumns[0]?.value || ''));
					this.$set(this.form, 'account_type', this.form.account_type || (this.accountColumns[0]?.type || ''));
				}
				this.initializeAccountActiveData();

			},
			// 筛选出选中的交易账号
			initializeAccountActiveData() {
				const index = this.accountColumns.findIndex(item => item.value == this.form.account_no);
				if (index != -1) {
					this.accountActiveData = [{ ...this.accountColumns[index] }];
				}
			},
			setStrategyId(strategyId) {
				if (strategyId == 0) {
					// 如果本地存储中没有当前策略ID，则默认赋予1
					let currentStrategyId = localStorage.getItem('currentStrategyId');
					this.strategyId = currentStrategyId || 1
				} else {
					this.strategyId = strategyId;
				}
				this.updateCurrentStrategyId()
			},
			updateCurrentStrategyId() {
				// 更新本地存储中的currentStrategyId，确保始终存储最新的策略ID
				localStorage.setItem('currentStrategyId', this.strategyId);
			},
			// 根据策略ID查找并更新策略名称
			handleStrategyId() {
				const index = this.strategyNamelistData.findIndex(item => item.strategyId == this.strategyId)
				if (index != -1) {
					this.changeStrategyName(this.strategyNamelistData[index])
				}
			},
			// 获取策略详情 -- 在获取完账号列表 之后 决定是否调用 (渲染问题)
			getStrategyInfoApi(){
				let { auto_id } = this;
	            // fetch('https://mock.mengxuegu.com/mock/665469e5b462b81cb391691a/gygj/edit').then( res => {return res.json(); })
				this.$apis.strategyInfoApi({ auto_id })
				.then(res=>{
					let { data } = res.data;

					// 部分详情数据 无需使用 所以一一赋值
					this.form.auto_id = Number(this.auto_id);
					this.form.account_no = data.account_no;
					this.form.strategy_id = data.strategy_id;
					this.form.strategy_name = data.strategy_name;
					this.form.strategy_type = data.strategy_type;
					this.form.symbol = data.symbol;
					this.form.exchange_code = data.exchange_code;
					this.form.account_type = data.account_type;
					this.form.commodity_type = data.commodity_type;
					this.form.commodity_no = data.commodity_no;
					this.form.strategy_param = data.account_no;
					this.form.contract_no = data.contract_no;
					this.wordKey = data.origin_symbol || data.commodity_no + data.contract_no;
          this.form.origin_symbol = this.wordKey;
					// 异常处理
					if (data.strategy_param && data.strategy_param != null && data.strategy_param != undefined) {
						try {
							this.strategy_param = JSON.parse(data.strategy_param);
						} catch (error) {
							
						}
					}
					this.isFirst = true;

					this.updateParams(data.trade_param);
					this.fetchDataSequence();

					this.getQuoteSymbolApi();
					this.symbolListShow = false;
					this.futureAndTick(this.form.symbol);
				});
			},
			// 更新交易参数和策略参数
			updateParams(query) {
				try {
					// 检查query是否为null、undefined或空字符串，如果是则直接返回，避免后续操作
					if (query == null || query === '') {
						return;
					}
					const trade_param = JSON.parse(query);
					// 更新交易参数中的订单类型和模式类型
					this.trade_param.order_type = trade_param.order_type;
					this.trade_param.modeType = trade_param.reference_lots.type;
					// 更新策略参数中的固定手数
					this.strategy_param.count = trade_param.reference_lots.fixed_lotsize;
					// 当订单类型为2时，更新账户编号
					if (trade_param.order_type === 2) {
						// 如果账户手数列表不为空，则获取第一个账户的编号
						if (trade_param.account_lots.length > 0) {
							this.account_no = trade_param.account_lots[0].account_no;
						}
					}
				} catch (error) {
					
				}
			},
			// 切换策略
			changeStrategyName(e){
				let { strategyId, strategyName, strategyType } = e;
				this.form.strategy_id = strategyId;
				this.form.strategy_name = strategyName;
				this.form.strategy_type = strategyType;
				this.strategyId = strategyType
				this.updateCurrentStrategyId()
			},
			// 获取策略列表
			getStrategyNameList() {
				return this.$apis.strategyNamelist().then(res=>{
					this.strategyNamelistData = [];
					if(res.data.data){
						res.data.data.map(item => {
							let cItem = {
								text: item.strategyName,
								value: item.strategyName,
								...item
							}
							this.strategyNamelistData.push(cItem);
						});
					}
				})
			},
			// 从缓存中读取之前存储的数据，如果存在对应策略ID的数据，则使用这些数据来预填充表单，
			loadCachedData() {
				const obj = this.readCache('myCache') || {};
				if (obj[this.strategyId]) {
					const { form, strategy_param, trade_param } = obj[this.strategyId];
					if (trade_param && Object.keys(trade_param).length > 0) {
						this.trade_param = trade_param;
					}
					// 先删除 account_no 后面在进行赋值操作
					this.account_no = form.account_no;
					delete form.account_no;
					this.form = form;
					this.wordKey = form.origin_symbol;
					this.strategy_param = strategy_param
					this.isFirst = true;
					this.getQuoteSymbolApi()
					this.symbolListShow = false;
					this.futureAndTick(this.form.symbol);
				} else {
					// 如果缓存中不存在当前策略ID的数据，则根据路由参数填充策略名称
					this.handleStrategyId();
				}
				this.fetchDataSequence();
			},
			// 切换交易账号
			changeAccountName(e){
				let { type, value } = e;
				this.form.account_type = type;
				this.form.account_no = value;
				this.account_no = value;
				this.chooseAccount();
			},
			// 参考手数
			changeCount(e) {
				const { value } = e;
				if (value == 1) {
					this.multiplier = 1;
				} else {
					this.getGroupTradeList();
				}
			},
			handWayChange(e) {
				this.trade_param.order_type = e.value;	// 赋值下单方式
				this.account_no = '';			// 重置交易账号
				this.form.account_no = '';			// 重置交易账号
				this.chooseAccount();
			},
			onDirectionChange(e) {
				
			},
			// 搜索名称代码
			getQuoteSymbolApi(){
				if(this.wordKey){
					this.symbolListShow = true;
					this.$apis.quoteSymbolApi({
						symbol: this.wordKey,
						contractType: 70,
						limit: 100
					}).then(res =>{
						let { infos } = res.data || {};
						this.symbolListData = infos || [];
						if(this.isFirst && infos && infos.length > 0){
							this.currentSymbolData = infos[0];
						}
					})
				}else{
					this.symbolListShow = false;
				}
			},
			// 选择名称代码
			checkStockName(item) {
				let { symbol,origin_symbol, exchange_code, commodity_no, contract_type, contract_no } = item;
				this.wordKey = origin_symbol;
				this.currentSymbolData = item;
				this.currentSymbolTickData = '';
				this.symbolListShow = false;
				this.form.symbol = symbol;
				this.form.exchange_code = exchange_code;
				this.form.commodity_no = commodity_no;
				this.form.commodity_type = contract_type;
				this.form.contract_no = contract_no;
        this.form.origin_symbol = origin_symbol;
				this.strategy_param.grid_size = '';
				this.isSetGridSize = false;
				this.futureAndTick(symbol);
				this.strategy_param.max = ''
				this.strategy_param.min = ''
			},
			// 获取快照 以及 sock tick
			// symbol 无数据 CME_ADmain ==> XXmain，且只多查询一次，main无数据刹车
			futureAndTick(symbol, lock = false){
				// 获取快照
				this.$apis.future_ticksnapshot({
					symbol
				}).then(res =>{
					// if((!res.data.future_ticks || !res.data.future_ticks[0]) && !lock){
					// 	let last = symbol.substring(symbol.length - 4);
					// 	let new_symbol = symbol.replace(last, 'main');
					// 	if(new_symbol && new_symbol.split('_')){
					// 		new_symbol = new_symbol.split('_')[1];
					// 		this.futureAndTick(new_symbol, true);
					// 		return;
					// 	}
					// }
					this.currentSymbolTickData = res.data.future_ticks[0];
					if(this.currentSymbolTickData && this.currentSymbolTickData.pre_closing_price && !this.strategy_param.grid_size){
						this.isSetGridSize = true;
						if(this.currentSymbolTickData.pre_closing_price){
							let num = this.currentSymbolTickData.pre_closing_price * 0.003;
							let arr = num.toString().split('.');
							let size = arr[0];
							if(arr[1] && this.currentSymbolData.digits > 0){
								size = size + '.' + arr[1].slice(0, this.currentSymbolData.digits);
							}
							this.strategy_param.grid_size = size;
						}
					}
					// 
				})
				// 行情 tick
				let struct = {
					MsgType: 'SubTicks',
					MsgBody: {
						symbol
					}
				}
        this.$socket.sendMsg(struct);
				// sendSock(struct);
				// getSock(this.getSockMsg)
			},
			// 更新行情
			getSockMsg(msg){
				if(this.form.symbol == msg.symbol){
					this.currentSymbolTickData = msg;
					// 快照可能无数据返回，所以选择tick的数据 设置默认格子大小 且 只设置一次
					if(!this.isSetGridSize && !this.strategy_param.grid_size){
						this.isSetGridSize = true;
						if(this.currentSymbolTickData.pre_closing_price){
							let num = this.currentSymbolTickData.pre_closing_price * 0.003;
							let arr = num.toString().split('.');
							let size = arr[0];
							if(arr[1] && this.currentSymbolData.digits > 0){
								size = size + '.' + arr[1].slice(0, this.currentSymbolData.digits);
							}
							this.strategy_param.grid_size = size;
						}
					}
				}
			},
			// 校验小数点是否超过限制长度
			checkPointLength(floatStr,length){
				let result = true;
				let arr = floatStr.split('.');
				if(arr.length > 1){
					if(arr[1].length > length){
						result = false;
					}
				}
				return result;
			},
			// 最高 最低校验
			checkMaxMin(){
				if(this.checkTimer){
					clearTimeout(this.checkTimer);
				}
				this.checkTimer = setTimeout(()=>{
					let { max, min, grid_size } = this.strategy_param;
					if((min && max) && parseFloat(min) >= parseFloat(max)){
						Toast('最高价需大于最低价!')
					}
					else if(!this.checkPointLength(max, 12)){
						Toast('小数点不得超过12位!')
					}
					else if(!this.checkPointLength(min, 12)){
						Toast('小数点不得超过12位!')
					}
					else if(!this.checkPointLength(grid_size, 12)){
						Toast('小数点不得超过12位!')
					}
					clearTimeout(this.checkTimer);
				},500)
			},
			// 手数加减
			countAddDel(type, step = 1){
				this.strategy_param.count = Number(this.strategy_param.count)
				if(type == 'add'){
					this.strategy_param.count += step;
				}else{
					if(this.strategy_param.count > 1){
						this.strategy_param.count -= step;
					}else{
						this.strategy_param.count = 1;
					}
				}
			},
			// 提交校验
			submitCheck(){
				// 校验
				if(!this.form.strategy_name){
					Toast('策略名称不能为空！');
					return;
				}
				if(!this.form.account_no){
					Toast('交易账号不能为空！');
					return;
				}
				if(!this.form.symbol){
					Toast('名称代码不能为空！');
					return;
				}
				this.confirmErrorList = [];
				// 策略名称不一样，字段会不一样 这里目前只有 类型1 的策略
				if(this.form.strategy_type == 1){
					if(!this.strategy_param.min || this.strategy_param.min == 0){
						Toast('最低价不能为空！');
						return;
					}
					if(!this.strategy_param.max || this.strategy_param.max == 0){
						Toast('最高价不能为空！');
						return;
					}
					if(parseFloat(this.strategy_param.max) <= parseFloat(this.strategy_param.min)){
						Toast('最高价需大于最低价！');
						return;
					}
					if(!this.checkPointLength(this.strategy_param.min, 12) || !this.checkPointLength(this.strategy_param.max, 12)){
						Toast('小数点不得超过12位!')
						return;
					}
					if(!this.strategy_param.grid_size || this.strategy_param.grid_size == 0){
						Toast('格子大小不能为空！');
						return;
					}

					if(!this.checkPointLength(this.strategy_param.grid_size, 12)){
						Toast('小数点不得超过12位!')
						return;
					}
					if(!this.strategy_param.count || this.strategy_param.count == 0){
						Toast('手数不能为空！');
						return;
					}
					if (/\./.test(this.strategy_param.count)) {
						Toast('手数必须是整数！');
						return;
					}
					// 此处需要二次确认的条件
					let pre_closing_price = this.currentSymbolTickData?.pre_closing_price;
					if(pre_closing_price){
						let { max, min, grid_size } = this.strategy_param;
						if(parseFloat(max) > pre_closing_price * 1.1 || parseFloat(min) < pre_closing_price * 0.9 || parseFloat(grid_size) < pre_closing_price * 0.0001){
							if(parseFloat(min) < pre_closing_price * 0.9){
								this.confirmErrorList.push('最低价，<span class="red">小于</span>上个交易日收盘价的<span class="red">90</span>%！')
							}
							if(parseFloat(max) > pre_closing_price * 1.1){
								this.confirmErrorList.push('最高价，<span class="red">大于</span>上个交易日收盘价的<span class="red">110</span>%！')
							}
							if(parseFloat(grid_size) < pre_closing_price * 0.0001){
								this.confirmErrorList.push('格子大小，<span class="red">小于</span>上个交易日收盘价的<span class="red">0.01</span>%！')
							}
							this.confirmDialogShow = true;
							return;
						}
					}
				} else if (this.form.strategy_type == 2) {
					if(!this.strategy_param.order_side){
						Toast('方向不能为空！');
						return;
					}
					if(!this.strategy_param.count || this.strategy_param.count == 0){
						Toast('手数不能为空！');
						return;
					}
					if (/\./.test(this.strategy_param.count)) {
						Toast('手数必须是整数！');
						return;
					}
					if(this.strategy_param.count > 100){
						this.confirmErrorList.push('数量已大于<span class="red">100手</span>!')
						this.confirmDialogShow = true;
						return;
					}
				} else {
					if(!this.strategy_param.count || this.strategy_param.count == 0){
						Toast('手数不能为空！');
						return;
					}
					if (/\./.test(this.strategy_param.count)) {
						Toast('手数必须是整数！');
						return;
					}
					if(this.strategy_param.count > 100){
						this.confirmErrorList.push('数量已大于<span class="red">100手</span>!')
						this.confirmDialogShow = true;
						return;
					}
				}
				this.submit();
			},
			// 点击修改倍数时，加标记
			markMultiple() {
				this.auto_id && localStorage.setItem('markMultiple', true);
			},
			// 去修改
			toChange(){
				this.confirmDialogShow = false;
			},
			// 提交
			submit(){
				this.strategy_param.count = Number(this.strategy_param.count);
				if (this.form.strategy_type == 1) {
					const obj = {
						max: parseFloat(this.strategy_param.max),
						min: parseFloat(this.strategy_param.min),
						grid_size: parseFloat(this.strategy_param.grid_size),
						count: this.strategy_param.count
					}
					this.form.strategy_param = JSON.stringify(obj);
				} else if (this.form.strategy_type == 2) {
					// 对于类型2的策略，只保留订单方向和计数参数，并转换为JSON字符串
					this.form.strategy_param = JSON.stringify({order_side: Number(this.strategy_param.order_side), count: this.strategy_param.count});
				} else {
					this.form.strategy_param = JSON.stringify({count: this.strategy_param.count, isOverNight: this.strategy_param.isOverNight});
				}
				this.form.account_no = String(this.form.account_no);
				this.form.trade_param = this.handleTransactionParams();
				if(this.auto_id){
					// 编辑
					this.$apis.strategyModifyApi(this.form).then(res => {
						if(res.data.error_code == 0){
							Toast('提交成功!');
							this.$router.push(`/h5-strategy-execution?strategyId=${this.strategyId}`);
							// 回到列表页面
						}else{
							Toast(res.data.error_msg)
						}
						this.isSubmit = true;
					});
				}else{
					// 新增
					this.$apis.strategyAddApi(this.form).then(res => {
						if(res.data.error_code == 0){
							Toast('提交成功!');
							this.$router.push(`/h5-strategy-execution?strategyId=${this.strategyId}`);
							// 回到列表页面
						}else{
							Toast(res.data.error_msg)
						}
						this.isSubmit = true;
					});
				}
			},
			// 处理交易参数
			handleTransactionParams() {
				const { trade_param: { order_type, modeType }, strategy_param: { count }, accountColumns, accountActiveData } = this;
				// 初始化查询对象并设置必要的属性
				const query = {
					order_type,
					trade_account: '',
					reference_lots: {
						type: modeType,
						fixed_lotsize: count
					},
					account_lots: []
				};
				// 使用短路求值来避免错误，并提升代码可读性
				const arr = order_type === 1 ? accountColumns : accountActiveData;
				// 只有当 arr 不为空时才构建 account_lots 数组
				if (arr.length) {
					query.account_lots = arr.reduce((acc, item) => {
						const multiple = modeType === 1 ? 1 : item.multiple ?? 1;
						const calculatedCount = modeType === 1 ? count : Math.floor(multiple * count);
						acc.push({
							account_no: String(item.value),
							count: calculatedCount,
							multiple
						});
						return acc;
					}, []);
				}
				return query;
			},
			readCache(key) {
				// 从localStorage获取键值对，如果不存在则返回null
				const cachedValue = localStorage.getItem(key);
				if (cachedValue) {
					return JSON.parse(cachedValue)
				} else {
					return null;
				}
			},
			writeCache(key, value) {
				// 检查key是否已存在
				const obj = this.readCache('myCache') || {}
				if (obj[key]) {
					delete obj[key]
				}
				obj[key] = value
				// 将新的键值对存储到localStorage
				localStorage.setItem('myCache', JSON.stringify(obj));
			},
		},
		destroyed() {
			let { strategy_name, strategy_id, strategy_type, account_type, account_no } = this.form;
			let keepData = {
				strategy_name, strategy_id, strategy_type, account_type, account_no
			};
			if(!this.isSubmit && !this.auto_id){
				sessionStorage.setItem('keepData', JSON.stringify(keepData));
			}
			if(this.isSubmit){
				sessionStorage.setItem('keepData', '');
			}
			// closeWebSocket();
      		this.$socket.stop();
			this.writeCache(this.strategyId, { form: this.form, strategy_param: this.strategy_param, trade_param: this.trade_param })
		}
	}
</script>

<style lang="less" scoped>
	.create-strategy{
		min-height: calc(100vh - 1.33333rem);
		background: #fff;
		padding-bottom: 20px;
	}
	/deep/ .van-hairline--bottom.nobor:after{
		display: none;
	}
	/deep/ .nobor .van-cell:after, .nobor.van-cell:after{
		display: none;
	}
	/deep/ .van-field__right-icon {
		align-self: inherit;
		padding-left: 0;
		padding-bottom: 0;
		padding-top: 8px;

		.van-icon {
			font-size: 40px;
		}
	}
	/deep/ .van-toast{
		min-height: 50px;
		.van-toast__text{

		}
	}
	/deep/ .count {
		width: 300px !important;
	}
	.overlay-top {
		margin-top: 366px;
		z-index: 100;
	}
	.form-box {
		padding: 0 24px 0 20px;
		background: #fff;
		// border-bottom: #fafafa solid 22px;
		&.last{
			border-bottom: none;
		}
		&.nobor{
			/deep/ .van-cell::after{
				display: none;
			}
		}
		/deep/ .van-field__label,
		/deep/ .van-field__control {
			color: #444;
		}

		/deep/ .symbolList-box .van-cell {
			padding: 0 24px;
		}

		/deep/ .van-cell {
			min-height: 100px;
			padding-right: 0;
		}
		.no-bor{
			&:after{
				display: none;
			}
		}
		.ipt-box {
			display: flex;
			align-items: center;
			flex: 1;
			.t {
				margin: 0 16px;
			}

			/deep/ .van-cell {
				min-height: 72px;
				line-height: 72px;

				&::after {
					display: block;
					height: 200%;
					border-color: #eee;
				}
			}
		}

		.item {
			display: flex;
			align-items: center;

			.btn-box {
				display: flex;
				margin-right: 16px;

				.btn {
					width: 40px;
					height: 40px;
					width: 52px;
					height: 54px;

					&.del {
						background: url('../../../assets/images/h5Page/del.png');
						background-size: 100% 100%;

						&.dis {
							background: url('../../../assets/images/h5Page/del_d.png');
							background-size: 100% 100%;
						}
					}

					&.add {
						background: url('../../../assets/images/h5Page/add.png');
						background-size: 100% 100%;
						margin-left: 28px;

						&.dis {
							background: url('../../../assets/images/h5Page/add_d.png');
							background-size: 100% 100%;
						}
					}
				}
			}
		}
		.sock-msg{
			height: 100px;
			display: flex;
			align-items: center;
			position: relative;
			.cont{
				position: absolute;
				left: -20px;
				right: -24px;
				top: 20px;
				height: 60px;
				line-height: 60px;
				display: flex;
				padding-left: 235px;
				box-sizing: border-box;
				justify-content: space-between;
				padding-right:24px;
				span{
					// flex: 1;
				}
				&.down{
					background: linear-gradient(to right, #e5f6eb, rgba(229, 246, 235, 0.30));
					color: #02AA39;
				}
				&.up{
					color: #E83324;
					background: linear-gradient(to right, rgba(255, 234, 232, 0.3), rgba(255, 234, 232, 0.5));
				}
			}
		}
	}
	.transaction {
		padding-top: 20px;
		.title {
			font-size: 32px;
			font-weight: bold;
			position: relative;
			margin: 10px 0px 12px 20px;
			&::after {
				content: '';
				width: 6px;
				height: 70%;
				background: #1C0955;
				position: absolute;
				left: -10px;
				top: 50%;
				transform: translateY(-50%)
			}
		}
	}
	.symbolList-box {
		max-height: 300px;
		overflow-y: auto;
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;
		background-color: #FAFAFC;
    .is_main{
      border: #4994df solid 1px;
      font-size: 20px;
      color: #4994df;
      padding: 5px;
      line-height: 20px;
      margin-left: 10px;
      border-radius: 5px;
    }
	}
	.noData{
		background-color: #FAFAFC;
		height: 300px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		.icon {
		  width: 126px;
		  height: 120px;
		  margin-bottom: 30px;
		}
		.text{
			color: #888888;
			font-size: 26px;
		}
	}
	.tips{
		padding-left: 215px;
		font-size: 24px;
		color: #FF9275;
		padding-bottom: 20px;
	}

	.btn-submit {
		margin: 85px 50px 0;
		height: 100px;
		line-height: 100px;
		text-align: center;
		background: #1C0955;
		font-size: 32px;
		color: #fff;
		border-radius: 4px;
		font-weight: 500;
		letter-spacing: 2px;
		box-shadow: 0px 5px 15px 0px rgba(0, 24, 112, 0.15);
	}
	.confirm-dialog{
		padding-bottom: 32px;
		/deep/ .van-dialog__header{
			padding-top: 32px;
		}
		.main{
			padding: 32px 30px;
			.text{
				font-size: 28px;
				margin-bottom: 15px;
				display: flex;
				/deep/ .red{
					color: #EB3323;
				}
			}
			.tip{
				font-size: 24px;
				color: #FF9275;
			}
		}
		.btn-box{
			display: flex;
			align-items: center;
			justify-content: space-between;
			// padding: 0;
			font-size: 28px;
			border-radius: 4px;
			@color: rgb(28, 9, 85);
			padding: 0 32px;
			.btn-item{
				flex: 1;
				border-radius: 4px;
				height: 80px;
				text-align: center;
				line-height: 80px;
				&:nth-child(1){
					border: 1px solid @color;
					color: @color;
				}
				&:nth-child(2){
					margin-left: 30px;
					background: @color;
					color: #fff;
				}
			}
		}
	}
</style>
